import Mousetrap from 'mousetrap';
import { generateIBAN, generateFirstName, generateRandomFromList, generateLastName, generateOndernemingsNummer, generatePhoneNumber, generateInfrastructuur, generateEMail, generateFunctie } from './EasterEggHelper';
import * as pageConstants from '../../constants/EasterEggConstants';
import mergeDeep from "../../util/mergeDeep.js";
import generateGuid from "../../util/guid.js";
import * as domainConstants from "../../constants/DomainConstants";

export default class EasterEggHandler {

    constructor(context, page) {
        this.called = 0;
        this.context = context;
        this.page = page;
        this.enabled = window.settings.EasterEggAutoFill;

        this.chooseAutoFill = this.chooseAutoFill.bind(this);
        this.fillAanvraagPage = this.fillAanvraagPage.bind(this);
        this.bind = this.bind.bind(this);
        this.unbind = this.unbind.bind(this);
    }

    initiateGemeenten(gemeenten) {
        this.gemeenten = gemeenten;
    }
    initiatePostcoden(postcoden) {
        this.postcoden = postcoden;
    }

    bind() {
        if (this.enabled)
            Mousetrap.bind([`up right down left enter`], this.chooseAutoFill);

    }
    unbind() {
        if (this.enabled)
            Mousetrap.unbind([`up right down left enter`], this.chooseAutoFill);

    }

    chooseAutoFill() {
        switch (this.page) {
            case pageConstants.AANVRAAG:
                this.fillAanvraagPage();
                break;
            case pageConstants.PROJECT:
                this.fillProjectPage();
                break;
            case pageConstants.MINIMALEEISENALGEMEEN:
                this.fillMinimaleEisenAlgemeen();
                break;
            case pageConstants.MINIMALEEISENINFRASTRUCTUUR:
                this.fillMinimaleEisenInfrastructuur();
                break;
            case pageConstants.BOVENLOKALITEITPERINFRASTRUCTUUR:
                this.fillBovenlokaliteitInfrastructuur();
                break;
            case pageConstants.CRITERIABOVENLOKAAL:
                this.fillBeoordelingscriteriaBovenlokaal();
                break;
            case pageConstants.CRITERIATOPSPORT:
                this.fillBeoordelingscriteriaTopsport();
                break;
            case pageConstants.VOORTGANGSRAPPORT_PROJECT:
                this.fillVRProject();
                break;
            case pageConstants.VOORTGANGSRAPPORT_BEOORDELINGSCRITERIA:
                this.fillVRBeoordelingscriteria();
                break;
            case pageConstants.VOORTGANGSRAPPORT_VERANTWOORDING:
                this.fillVRVerantwoording();
                break;
            case pageConstants.SIMULATIEDOSSIER:
                this.fillSimulatieDossier();
                break;
            case pageConstants.SIMULATIEPERINFRASTRUCTUUR:
                this.fillSimulatiePerInfrastructuur();
                break;
            case pageConstants.INFRASTRUCTUURINDEBUURT:
                this.fillInfrastructuurInDeBuurt();
                break;
        }
    }

    //-------------------------------------------------------------------
    fillAanvraagPage() {
        let gemeente = generateRandomFromList(this.gemeenten);
        let postcode = generateRandomFromList(this.postcoden);
        let aanvraag = {
            "aanvragers":
                [
                    {
                        "anderJuridischStatuut": null,
                        "btwAftrekbaar": false,
                        "juridischeStatuut": 121450017,
                        "naam": "Sport Vlaanderen",
                        "ondernemingsNr": generateOndernemingsNummer(),
                        "straat": "Arenbergstraat 1D",
                        "postcode": postcode ? postcode.value : null,
                        "plaats": gemeente ? gemeente.value : null,
                        "mandatarissen": [
                            {
                                "functie": generateFunctie(),
                                "naam": generateLastName(),
                                "voornaam": generateFirstName()
                            }
                        ]
                    }
                ],
            "contactpersoon1": {
                "email": generateEMail("Jef", "Vermeulen"),
                "functie": generateFunctie(),
                "tel": generatePhoneNumber(),
                "naam": generateLastName(),
                "voornaam": generateFirstName()
            },
            "contactpersoon2": {
                "email": generateEMail("Jef", "Vermeulen"),
                "functie": generateFunctie(),
                "tel": generatePhoneNumber(),
                "naam": generateLastName(),
                "voornaam": generateFirstName()
            },
            "rekeningNummer": generateIBAN(),
            "naam": "Ingevuld Dossier"
        };
        this.context.setState({ aanvraag: mergeDeep(this.context.state.aanvraag, aanvraag) });
    }

    fillProjectPage() {
        const infrastructuur = generateInfrastructuur();
        const infrastructuur2 = generateInfrastructuur();

        let gemeente = generateRandomFromList(this.gemeenten);
        let postcode = generateRandomFromList(this.postcoden);
        const project = {
            "postcode": postcode ? postcode.value : null,
            "gemeente": gemeente ? gemeente.value : null,
            "infrastructuren": [
                {
                    "naam": infrastructuur.name,
                    "soortInfrastructuur": infrastructuur.id,
                    "typeDossier": 121450001,
                    "oorspronkelijkBouwjaar": "2000",
                    "jaarLaatsteGrondigeRenovatie": "2015"
                },
                {
                    "naam": infrastructuur2.name,
                    "soortInfrastructuur": infrastructuur2.id,
                    "typeDossier": 121450001,
                    "oorspronkelijkBouwjaar": "2000",
                    "jaarLaatsteGrondigeRenovatie": "2015"
                }
            ],
            "uitsluitendInrichtingVanTopsportInfrastructuren": false,
            "omschrijving": "Omschrijving van dit mooie project.",
            "straatHuisnummer": "Arenbergstraat 1D",
            "soortDossier": domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE,
            "breedtegraad": "51.020971",
            "lengtegraad": "3.6397549"
        };

        this.context.setState({ project: mergeDeep(this.context.state.project, project) });
    }

    fillMinimaleEisenAlgemeen() {
        //FIX ISSUE
        const guid = generateGuid();
        const minimaleEisen = {
            "werkenTijdigGestart": true,
            "welkeWerkenGestart": "Alle werken.",
            "opengesteldVoorBreedPubliek": false,
            "infrastructuurMarktconform": false,
            "financiers": [{
                id: guid,
                naam: "",
                aandeelInBedrag: null,
                aandeelInPercent: null,
                isNew: true
            }]/*
                {
                    "naam":"Test",
                    "aandeelInBedrag":5000
                }
            ]*/
            //"opbrengstKostInvesteringen":[{"typeId":"ef66bb0d-de01-e811-810f-5065f38be551","subtypeId":"52ca0730-de01-e811-8114-5065f38ada11","opbrengstenOfKostenPostId":"ca77b379-de01-e811-810f-5065f38be551","omschrijving":"Lidgeld","isNew":true,"bedragJaar1":"10000","bedragJaar2":"10000","bedragJaar3":"10000","bedragJaar4":"10000","bedragJaar5":"10000","bedragJaar6":"10000","bedragJaar7":"10000","bedragJaar8":"10000","bedragJaar9":"10000","bedragJaar10":"10000"},{"id":"c9b05b60-14cb-437e-a527-9830eb05ea8d","typeId":"f166bb0d-de01-e811-810f-5065f38be551","subtypeId":"58ca0730-de01-e811-8114-5065f38ada11","opbrengstenOfKostenPostId":"0278b379-de01-e811-810f-5065f38be551","omschrijving":"Promomateriaal Sport Vlaanderen","isNew":true,"bedragJaar1":"4500","bedragJaar2":"3000","bedragJaar3":"2000","bedragJaar4":"5000","bedragJaar5":"6000","bedragJaar6":"8000","bedragJaar7":"8000","bedragJaar8":"10000","bedragJaar9":"2000","bedragJaar10":"2500"}]
        };

        this.context.setState({ minimaleEisenPerDossier: mergeDeep(this.context.state.minimaleEisenPerDossier, minimaleEisen), financiers: minimaleEisen.financiers });
    }

    fillMinimaleEisenInfrastructuur() {
        const minimaleEisen = {
            "heeftAanvragerLandurigZakelijkRecht": false,
            "werkvergunningPlichtig": true,
            "stedenbouwkundigeBestemming": 121450000,
            "eigenlijkeBestemming": "Wonen",
            "latenDeVoorschriftenInplantingToe": false,
            "toelichtingInplanting": "Mag niet",
            "bpaVanToepassing": false,
            "rupVanToepassing": false,
            "merVanToepassing": false,
            "vanToepassingInschattingDatumRUP": false,
            "vanToepassingOpstartOverheidsopdracht": false,
            "vanToepassingEindeOverheidsopdracht": false,
            "vanToepassingAanvragOmgevingsvergunning": false,
            "vanToepassingVerkrijgenOmgevingsvergunning": false,
            "startWerken": "2018-04-11T00:00:00+00:00",
            "voorlopigeOplevering": "2018-04-11T00:00:00+00:00",
            "opening": "2018-04-11T00:00:00+00:00",
            "definitieveOplevering": "2018-04-11T00:00:00+00:00",
            "opmerkingenDefinitieveOplevering": null,
            "akkoordSportVlaanderenVoorlopigeOpleveringBinnen3Jaar": null,
            "motiveringSportVlaanderenVoorlopigeOpleveringBinnen3Jaar": null,
            "isHetProjectEnergetischDuurzaam": 121450001,
            "vergunningAlAanwezig": false,
            "projectBesprokenMetGemeentedienstStedenbouw": false,
            "werkvergunningPlichtigStedenbouw": false,
            "werkvergunningPlichtigLeefmilieu": false
        };

        this.context.setState({ minimaleEisenPerInfrastructuur: mergeDeep(this.context.state.minimaleEisenPerInfrastructuur, minimaleEisen) });
    }

    fillBovenlokaliteitInfrastructuur() {
        const bovenlokaliteit = {
            "aantalBedden": 10,
            "hoogte": 5,
            "oppervlakte": 500,
            "geenInfrastructurenInDeBuurt": true,
            "topsportGelegenheid": false,
            "volume": 300
        };
        this.context.setState({ bovenLokaliteitPerInfrastructuur: mergeDeep(this.context.state.bovenLokaliteitPerInfrastructuur, bovenlokaliteit) });
    }

    fillBeoordelingscriteriaBovenlokaal() {
        const fileComponents = [{
            name: "Inplantingsplan voor de werken",
            files: [{ name: "testFile1.pdf" }]
        },
        {
            name: "Inplantingsplan na de werken",
            files: [{ name: "testFile1.pdf" }]
        }];

        const beoordelingscriteria = {
            "plannenBeschikbaar": false,
            "omgevingsAnalyse": "Analyse",
            "bijdrageAanSportlandschap": "Bijdragen",
            "bereikDoelgroepenVolgende5Jaar": [{ doelgroep: 121450002, aantalBezoekersJaar1: 10, aantalBezoekersJaar2: 20, aantalBezoekersJaar3: 30, aantalBezoekersJaar4: 40, aantalBezoekersJaar5: 50 }],
            "bereikDoelgroepenVorige5Jaar": [{ doelgroep: 121450003, aantalBezoekersJaar1: 10, aantalBezoekersJaar2: 20, aantalBezoekersJaar3: 30, aantalBezoekersJaar4: 40, aantalBezoekersJaar5: 50 }],
            "toelichtingCijfersBereik": "Toelichting",
            "multimodaleOntsluiting": "MultimodaleOntsluiting",
            "invullingenUitbatingBinnen20Jaar": "Invullingen Uitbating Binnen 20 Jaar",
            "stappenRichtingToekomstvisie": "Stappen Richting Toekomstvisie",
            "aandachtZuinigRuimtegebruik": "Aandacht Zuinig Ruimtegebruik",
            "innovatiesSportparticipatie": "Innovaties Sportparticipatie",
            "ondersteunendeDienstenEnProducten": "Ondersteunende Diensten En Producten",
            "samenwerkingsVerbanden": false,
            "inclusiefAanbod": "aanbod",
            "ontwerpenVoorIedereen": "ontwerp",
            "garantieIntegraleToegankelijkheid": "garantie",
            "motiveringSamenwerkingsVerbanden": "motivering"
        };
        this.context.setState({
            beoordelingscriteria: mergeDeep(this.context.state.beoordelingscriteria, beoordelingscriteria),
            documenten: fileComponents
        });
    }

    fillBeoordelingscriteriaTopsport() {
        const beoordelingscriteria = {};
        this.context.setState({ beoordelingscriteria: mergeDeep(this.context.state.beoordelingscriteria, beoordelingscriteria) });
    }

    fillInfrastructuurInDeBuurt() {
        const model = {
            "soortInfrastructuurId": this.context.props.soortenInfrastructuur[0].id,
            "naam": "mooie infrastructuur"
        };

        this.context.setState({ model });
    }

    fillVRProject() {
        const vrProject = {
            "indienerNaam": generateFirstName() + " " + generateLastName(),
            "indienerFunctie": generateFunctie(),
            "indienerEmail": generateEMail(),
            "isOmschrijvingProjectGewijzigd": true,
            "toelichtingWijzigingOmschrijvingProject": "de toelichting",
            "toelichtingFaseProject": "de toelichting",
            "vooropgesteldeOpleveringsdatum": "2018-04-11T00:00:00+00:00",
            // "initieleOpleveringsdatum": "2018-04-11T00:00:00+00:00",
            "toelichtingAfwijkendeDatumOplevering": "de toelichting",
            "vooropgesteldeOpeningsdatum": "2018-04-11T00:00:00+00:00",
            // "initieleOpeningsdatum": "2018-04-11T00:00:00+00:00",
            "toelichtingAfwijkendeDatumOpening": "de toelichting",
            "isEindrapport": true
        };
        this.context.setState({ vrProject: mergeDeep(this.context.state.vrProject, vrProject) });
    }

    fillVRBeoordelingscriteria() {
        const vrBeoordelingscriteria = {
            "wijzigingenCriteriaBehoefte": true,
            "toelichtingWijzigingenCriteriumBehoefte": "toelichting bij wijziging",
            "wijzigingenCriteriaBereik": true,
            "toelichtingWijzigingenCriteriumBereik": "toelichting bij wijziging",
            "realisatieProject": "realisatie van het project",
            "exploitatieProject": "exploitatie van het project",
            "andereSamenwerkingsverbanden": "andere samenwerkingsverbanden jaja",
            "actiesInclusiefAanbodBezoekers": "acties en aantal bezoekers",
            "integraleToegankelijkheidInfrastructuur": "text",
            "innovatieveEigenschappenGebouw": "nog text",
            "innovatieveEigenschappenExploitatie": "nog meer text",
            "innovatieveEigenschappenSporttechnisch": "teeext",
            "innovatieveEigenschappenSamenwerkingSV": "tekst",
            "innovatieveEigenschappenTrends": "texkst",
            "innovatieveEigenschappenMaatschappelijkeInnovatie": "testtext",
            "toelichtingCommunicatieLogoSV": "noog text",
            "opmerkingen": "laatste text"
        };
        this.context.setState({ vrBeoordelingscriteria: mergeDeep(this.context.state.vrBeoordelingscriteria, vrBeoordelingscriteria) });
    }

    fillVRVerantwoording() {
        const vrVerantwoording = {
            "totaalbedragInclBTW": 12345,
            "totaalbedragExclBTW": ((12345 * 1000) * 0.79) / 1000
        };
        this.context.setState({ vrVerantwoording: mergeDeep(this.context.state.vrVerantwoording, vrVerantwoording) });
    }

    fillSimulatieDossier() {
        const infrastructuur = generateInfrastructuur();
        const dossierId = generateGuid();
        let gemeente = generateRandomFromList(this.gemeenten);
        let postcode = generateRandomFromList(this.postcoden);
        const simulatieDossier = {
            "isStored": false,
            "emailControle": null,
            "dossierPDFGegenereerd": null,
            "datumDossierPDFGeneratie": null,
            "andereInfrastructurenBeschikbaar": null,
            "version": 0,
            "dossierNummer": null,
            "typeDossier": 121450001,
            "naam": generateFirstName() + " " + generateLastName(),
            "omschrijving": "omschrijving",
            "email": generateEMail(),
            "naamleidinggevende": null,
            "straatHuisnummer": "asdvds",
            "postcode": postcode ? postcode.value : null,
            "gemeente": gemeente ? gemeente.value : null,
            "breedtegraad": "51.020971",
            "lengtegraad": "3.6397549",
            "startenWerkenNaUitersteIndieningsDatum": true,
            "heeftAanvragerLangdurigZakelijkRecht": true,
            "infrastructuurOpengesteldVoorBreedPubliek": true,
            "infrastructuurMarktconform": true,
            "financieelDuurzaamEnHaalbaar": true,
            "kanOmgevingsvergunningWordenBehaald": 121450000,
            "opleveringBinnenDrieJaar": true,
            "isHetProjectEnergetischDuurzaam": 121450000,
            "minimaalGeinvesteerd": true,
            "infrastructuren": [{
                "version": 0,
                "naam": "ascvsfdv",
                "dossier": {
                    "display": null
                },
                "sporttak": null,
                "soortInfrastructuur": "5a1cf9e0-325b-e711-8107-e0071b66f051",
                "andereInfrastructuur": "",
                "breedtegraad": "51.020971",
                "lengtegraad": "3.6397549"
            }],
            "redenVanStatus": null,
            "statusSimulatie": null,
            "scoreBovenlokaliteit": null,
            "bovenlokaliteitHoogsteScore": null,
            "minimaleEisenPositief": null,
            "soortDossier": domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE
        };
        this.context.setState({ simulatieDossier: mergeDeep(this.context.state.simulatieDossier, simulatieDossier), newCoordinates: { lat: "51.020971", lng: "3.6397549" } });
    }

    fillSimulatiePerInfrastructuur() {
        const simulatiePerInfrastructuur = {
            "aantalBedden": 456,
            "hoogte": 234,
            "oppervlakte": 123,
            "topsportGelegenheid": false,
            "volume": 345
        };
        this.context.setState({ simulatiePerInfrastructuur: mergeDeep(this.context.state.simulatiePerInfrastructuur, simulatiePerInfrastructuur) });
    }
}